/* Accessible mobile footer. No dependency on app.js, heights or animations. */
(function () {
  'use strict';
  if (window.DMFooterAccordion) {
    window.DMFooterAccordion.init(document);
    return;
  }

  var instances = new Map();

  function mount(footer) {
    if (instances.has(footer)) return;
    var media = window.matchMedia('(max-width: 767px)');
    var items = [];

    footer.querySelectorAll('[data-dm-footer-item]').forEach(function (block) {
      var button = block.querySelector('[data-dm-footer-toggle]');
      var panel = block.querySelector('[data-dm-footer-panel]');
      if (!button || !panel) return;
      var item = {
        block: block,
        button: button,
        panel: panel,
        open: block.getAttribute('data-open-default') === 'true'
      };
      item.click = function () {
        if (!media.matches) return;
        item.open = !item.open;
        render(item);
      };
      button.addEventListener('click', item.click);
      items.push(item);
    });

    function render(item) {
      var expanded = !media.matches || item.open;
      item.button.disabled = !media.matches;
      item.button.setAttribute('aria-expanded', String(expanded));
      item.panel.hidden = !expanded;
      item.block.classList.toggle('is-open', expanded);
    }

    function refresh() {
      items.forEach(render);
    }

    function revealHash() {
      if (!window.location.hash) return;
      var targetId;
      try { targetId = decodeURIComponent(window.location.hash.slice(1)); }
      catch (error) { return; }
      var target = document.getElementById(targetId);
      if (!target) return;
      items.forEach(function (item) {
        if (item.panel === target || item.panel.contains(target)) {
          item.open = true;
          render(item);
        }
      });
    }

    function selectBlock(event) {
      if (!event.detail || !event.detail.blockId) return;
      items.forEach(function (item) {
        if (item.block.getAttribute('data-dm-block-id') === event.detail.blockId) {
          item.open = true;
          render(item);
        }
      });
    }

    if (media.addEventListener) media.addEventListener('change', refresh);
    else media.addListener(refresh);
    footer.addEventListener('shopify:block:select', selectBlock);
    window.addEventListener('hashchange', revealHash);
    refresh();
    revealHash();
    footer.classList.add('dm-footer-ready');

    instances.set(footer, function () {
      items.forEach(function (item) {
        item.button.removeEventListener('click', item.click);
        item.button.disabled = false;
        item.button.setAttribute('aria-expanded', 'true');
        item.panel.hidden = false;
      });
      if (media.removeEventListener) media.removeEventListener('change', refresh);
      else media.removeListener(refresh);
      footer.removeEventListener('shopify:block:select', selectBlock);
      window.removeEventListener('hashchange', revealHash);
      footer.classList.remove('dm-footer-ready');
      instances.delete(footer);
    });
  }

  function init(root) {
    instances.forEach(function (destroy, footer) {
      if (!footer.isConnected) destroy();
    });
    if (root.matches && root.matches('[data-dm-footer]')) mount(root);
    root.querySelectorAll('[data-dm-footer]').forEach(mount);
  }

  window.DMFooterAccordion = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, footer) {
      if (event.target === footer || event.target.contains(footer)) destroy();
    });
  });
})();
